import React from 'react'
import {NavLink, useLocation} from 'react-router-dom'
import {useSelector} from 'react-redux'
import {reduxProps} from '../../constants'
import {UiIcon} from '../../components/UiIcon'
import './StudentNavigation.scss'

export function NavButtonGroup() {
  const {classroom} = useSelector((state: reduxProps) => state.educationReducer)
  const {pathname} = useLocation()
  if (!classroom?.b2CClass && /^\/student\/?$/.test(pathname)) return null
  return <nav className='student-navigation' aria-label='Öğrenci işlemleri'>
    <NavLink to='/student' end className={({isActive}) => isActive ? 'is-active' : ''}><UiIcon name='people' size={17}/>Tüm öğrenciler</NavLink>
    {classroom?.b2CClass && <>
      <NavLink to='/student/add' className={({isActive}) => isActive ? 'is-active' : ''}><UiIcon name='plus' size={17}/>Öğrenci ekle</NavLink>
      <NavLink to='/classroom/share' className={({isActive}) => isActive ? 'is-active' : ''}><UiIcon name='arrow' size={17}/>Sınıfı paylaş</NavLink>
    </>}
  </nav>
}
